export const LogoutPath = '/logout';
export const LoginPath = '/login';
export const SignupPath = '/signup';
export const SignupStepPath = {
  path: '/signup/:step',
  withStep: (step: string): string => {
    return SignupStepPath.path.replace(':step', step);
  },
};
